import { Button, Card, Footer, Input } from '@scuf/common'
import './Login.css'
import '../../index.css'
import React, { type FormEvent, useState } from 'react'
import forgeLogo from '../../assets/Forge-Logo.svg'
import { useAuth } from 'react-oidc-context'
import LanguageStrings from '../../i18n/locales'

const dashboardStrings = LanguageStrings().Dashboard
const loginStrings = LanguageStrings().login

const Login = (): any => {
  const authContext = useAuth()
  const [username, setUsername] = useState('')
  const [error, setError] = useState<string | undefined>(undefined)
  const [enabled, setEnabled] = useState(false)

  const onSubmit = (event: FormEvent<HTMLFormElement>): void => {
    event.preventDefault()
    authContext
      .signinRedirect({
        login_hint: username
      })
      .catch((e) => {
        console.log(e)
      })
  }

  const onUsernameChange = (value: string): void => {
    const regex = /^(?=.{1,200}$)[^@]+@[^@]+\.[^@]+$/
    if (value === '') {
      setError(undefined)
      setEnabled(false)
    } else if (regex.test(value)) {
      setError(undefined)
      setEnabled(true)
    } else if (value.length > 200) {
      setError(loginStrings.Maximumemaillengthshouldnotbemorethan200)
    } else {
      setError(loginStrings.Enteravalidemailaddress)
      setEnabled(false)
    }
    setUsername(value)
  }

  return (
    <React.StrictMode>
      <div className="login-layout">
        <Card className="rounded login-card">
          <Card.Content>
            <form onSubmit={onSubmit} className="login-form">
              <img
                src={forgeLogo}
                alt="Honeywell Forge Logo"
              />
              <h4>{loginStrings.SignIn}</h4>
              <Input
                className="rounded"
                value={username}
                error={error}
                onChange={onUsernameChange}
                placeholder={loginStrings.Username}
                label={loginStrings.Username}
                reserveSpace={true}
                fluid={true}
                arial-label="username-label"
              />
              <Button
                className="rounded"
                type="primary"
                content={loginStrings.SignIn}
                actionType="submit"
                disabled={!enabled}
                textTransform={false}
              />
              <div className="honeywell-privacy-statement">
                <p>{loginStrings.Yourpersonaldatawillbeprocessedin}</p>
                <p>{loginStrings.accordancewith}</p>
                <a target='_blank' rel="noreferrer noopener" href="https://www.honeywell.com/us/en/privacy-statement">
                  {loginStrings.HoneywellPrivacyStatement}
                </a>
              </div>
            </form>
          </Card.Content>
        </Card>
      </div>
      <Footer style={{ width: '100%', position: 'fixed', bottom: 0 }}>
        <Footer.Item
          href="https://www.honeywell.com/us/en/privacy-statement"
          target="_blank"
        >
          {dashboardStrings.Privacy_Policy}
        </Footer.Item>
        <Footer.Item
          href="https://Honpat.com"
          target="_blank"
        >
          {dashboardStrings.Patents}
        </Footer.Item>
      </Footer>
    </React.StrictMode>
  )
}

export default Login
